import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: COLORS.LIGHT_GREY,
    borderLeft: `6px solid ${COLORS.PRIMARY}`,
    borderRadius: '0 8px 8px 0',
    padding: '16px 20px',
    columnGap: 12,
    color: COLORS.PRIMARY,
  },
  icon: {
    flexShrink: 0,
    display: 'flex',
  },
  text: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.regular,
    fontSize: 14,
    lineHeight: 1.4,
    color: COLORS.PRIMARY,
  },
})

export { useStyles }
